"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsDeveloper = void 0;
const button_1 = require("client/components/material/button");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const router_1 = require("client/components/router");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const store_1 = require("../../store");
require("./app-settings-developer.less");
let AppSettingsDeveloper = class AppSettingsDeveloper extends React.Component {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.didChange = false;
        this.originalSettings = null;
        this.loadSettings = async () => {
            const settings = await store_1.appSettingsStore.readSettings();
            const cleaned = settings
                .filter((setting) => setting.devOnly)
                .sort((a, b) => a.category > b.category ? 1 : -1)
                .map((e) => e);
            this.settings = cleaned;
            this.originalSettings = cleaned;
        };
        this.handleUpdateValue = (i) => (e, v) => {
            this.settings[i].value = v;
            this.checkChange();
        };
        this.handleUpdateTriggerValue = (i, type, label) => (e, v) => {
            const value = JSON.parse(this.settings[i].value);
            value[type][label] = v;
            this.settings[i].value = JSON.stringify(value);
            this.checkChange();
        };
        this.handleClickTrigger = async (setting) => {
            const result = await store_1.appSettingsStore.callTrigger(setting);
            if (result.message)
                alert(result.message);
        };
        this.handleSubmit = async () => {
            const result = await store_1.appSettingsStore.updateSettings(this.settings);
            this.didChange = false;
            await this.loadSettings();
        };
    }
    async componentDidMount() {
        await this.loadSettings();
    }
    async componentWillUnmount() {
        this.settings = null;
        this.originalSettings = null;
    }
    checkChange() {
        const cleanObj = this.settings.map((e) => e);
        const isDiff = ramda_1.difference(Object.entries(cleanObj), Object.entries(this.originalSettings));
        this.didChange = isDiff.length > 0;
    }
    renderSettings() {
        const settings = this.settings;
        const groups = [];
        const blocks = [];
        let count = 0;
        settings.forEach((setting) => {
            const groupName = setting.category;
            if (!groups.includes(groupName))
                groups.push(groupName);
        });
        groups.forEach((group) => {
            blocks.push(React.createElement("div", { className: "settings__block" },
                React.createElement("h3", { className: "settings__block-title", id: group }, group.toUpperCase()),
                React.createElement("div", { className: "settings__block-entries" }, settings
                    .filter((setting) => setting.category === group)
                    .map((e) => {
                    const i = count;
                    const name = e.displayName;
                    const desc = e.description;
                    const value = e.value;
                    const type = e.settingType;
                    let display;
                    switch (type) {
                        case app_settings_1.AppType.string:
                            display = (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateValue(i), type: "text", label: name, value: value }));
                            break;
                        case app_settings_1.AppType.boolean:
                            display = (React.createElement(switch_1.MaterialSwitch, { onChange: this.handleUpdateValue(i), label: name, checked: value === "1" || value === true }));
                            break;
                        case app_settings_1.AppType.number:
                            display = (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateValue(i), className: "settings__block-entry--number", type: "number", label: name, value: value }));
                            break;
                        case app_settings_1.AppType.array:
                            display = (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateValue(i), type: "text", label: name, value: value }));
                            break;
                        default:
                            display = React.createElement(React.Fragment, null);
                    }
                    if (type === app_settings_1.AppType.trigger) {
                        const triggerValue = JSON.parse(value);
                        const { arrays, booleans, numbers, properties, strings } = triggerValue;
                        const useString = !!strings && (React.createElement(React.Fragment, null, Object.entries(strings).map((entry) => (React.createElement(text_field_1.MaterialTextField, { onChange: this.handleUpdateTriggerValue(i, "strings", entry[0]), type: "text", label: entry[0], value: entry[1] })))));
                        const useBoolean = !!booleans && (React.createElement(React.Fragment, null, Object.entries(booleans).map((entry) => (React.createElement(switch_1.MaterialSwitch, { onChange: this.handleUpdateTriggerValue(i, "booleans", entry[0]), label: entry[0], checked: entry[1] === "1" || entry[1] === true })))));
                        const useArray = !!arrays && (React.createElement(React.Fragment, null));
                        const useNumber = !!numbers && (React.createElement(React.Fragment, null, Object.entries(numbers).map((entry) => (React.createElement(text_field_1.MaterialTextField, { className: "settings__block-entry--number", onChange: this.handleUpdateTriggerValue(i, "numbers", entry[0]), type: "number", label: entry[0], value: entry[1] })))));
                        display = (React.createElement(React.Fragment, null,
                            useString,
                            useBoolean,
                            useArray,
                            useNumber,
                            React.createElement(button_1.MaterialButton, { secondary: true, onClick: () => this.handleClickTrigger(e), className: "settings__block-entry--body-disp-btn" }, "Execute")));
                    }
                    count++;
                    return (React.createElement("div", { className: "settings__block-entry" },
                        React.createElement("div", { className: "settings__block-entry--title" }, name),
                        React.createElement("div", { className: "settings__block-entry--body" },
                            React.createElement("span", { className: "settings__block-entry--body-desc" }, desc),
                            React.createElement("span", { className: "settings__block-entry--body-disp" }, display))));
                }))));
        });
        const wrapper = (React.createElement("div", { className: "dev-settings" },
            React.createElement("div", { className: "settings__wrapper" },
                React.createElement("div", { className: "settings__block" }, blocks.map((e) => e)),
                React.createElement("div", { className: "settings__submit" },
                    React.createElement(button_1.MaterialButton, { primary: true, className: "settings__submit--button", disabled: !this.didChange, onClick: this.handleSubmit }, "Save")),
                React.createElement("div", { className: "settings__links", style: { margin: "0 auto" } },
                    React.createElement("ul", { style: { margin: "0 auto", width: "fit-content" } },
                        React.createElement("li", null,
                            React.createElement("a", { onClick: () => router_1.RouteManager.transitionTo("/sink") }, "Kitchen Sink")),
                        React.createElement("li", null,
                            React.createElement("a", { style: { color: "black", textDecoration: "none" }, href: "https://www.caremark.com/portal/asset/CVSCaremarkPayerSheetRejectCodes.pdf", target: "_blank" }, "Caremark Reject Codes")),
                        React.createElement("li", null,
                            React.createElement("a", { style: { color: "black", textDecoration: "none" }, href: "https://ushik.ahrq.gov/Search", target: "_blank" }, "USHIK NCPDP Lookup")),
                        React.createElement("li", null,
                            React.createElement("a", { style: { color: "black", textDecoration: "none" }, href: "https://www.express-scripts.com/art/prc/NCPDP_vD0_MEDICAID_Payer_Sheet.pdf", target: "_blank" }, "Express Scripts Payer Sheet")))))));
        return wrapper;
    }
    render() {
        const didLoad = !!this.settings;
        return (React.createElement("div", null, didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsDeveloper.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsDeveloper.prototype, "didChange", void 0);
AppSettingsDeveloper = __decorate([
    mobx_react_1.observer
], AppSettingsDeveloper);
exports.AppSettingsDeveloper = AppSettingsDeveloper;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-developer/app-settings-developer.tsx
// module id = 3185
// module chunks = 0